

import * as model from '@model'
import {isStringNullOrEmpty} from "@/utils";

const mapUrlIds:any = {};

export const imgServer = {
    imgMap: new Map(),
    imgMapSrcLocal:new Map(),
    blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.onload = (e: any) => {
                resolve(e.target.result)
            }
            // readAsDataURL
            fileReader.readAsDataURL(blob)
            fileReader.onerror = () => {
                reject(new Error('blobToBase64 error'))
            }
        })
    },
    getLocalImage(src){
      return imgServer.imgMapSrcLocal.get(src);
    },
    downUrl(url,szSufix="",callback) {
        if (url.startsWith('localfile://') || url.startsWith('atom://')){
            return;
        }
        if (imgServer.imgMap.get(szSufix+url)){
            //已经有了，不要再下载了....
            return;
        }

        // window.open(_this.detail.imgUrl)
        let xmlhttp = new XMLHttpRequest();
        const id = crypto.randomUUID();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = async function () {
            if (this.status == 200) {
                const blob = this.response;
                // console.log('blob: ', blob);
                const data = await imgServer.blobToBase64(blob)
                await model.addImg(id, data)

                imgServer.imgMap.set(szSufix+url, 'src="atom://' + id + '.jpeg"')
                imgServer.imgMapSrcLocal.set(szSufix+url,"atom://" + id + ".jpeg");
                const el:any = document.querySelector(`img[src="${url}"]`)
                if (el){
                    el.src="atom://" + id + ".jpeg"
                }

                if (callback){
                    callback(szSufix);
                }
            }else{
                const el:any = document.querySelector(`img[src="${url}"]`)
                if (el){
                    console.log('el: ', el);
                    // @ts-ignore
                    el.src='atom://note-place-img.jpeg'
                    imgServer.imgMap.set(url, 'src="atom://note-place-img.jpeg"')
                }
            }
        }
        xmlhttp.send();
        return id
    },
    getImgFromHtml(html,szSufix:any='',callback) {
        //这种就直接替换掉了？？？？逻辑有问题
        return html.replace(/src=[\'\"]([^\'^\"]+)[\'\"]/g, (str) => {
            const url = str.replace(/^(src=[\'\"])([^\'^\"]+)([\'\"])$/, '$2')
            imgServer.downUrl(url,szSufix,callback);
            return str
        })
    },
    parserImgFromHtml(html,szSufix:any = '') {
        return html?.replace(/src=[\'\"]([^\'^\"]+)[\'\"]/g, (str) => {
                // 防止youtube插件中src受到干扰 = 如果在 <iframe> 中，保留原内容
                if (/^<iframe\b/i.test(html.substring(html.lastIndexOf('<', html.indexOf(str)), html.indexOf(str)))) {
                    return str;
                }

                const url = str.replace(/^(src=[\'\"])([^\'^\"]+)([\'\"])$/, '$2')
                // console.log('url: ', url);
                // console.log('imgServer.imgMap.get(url): ', imgServer.imgMap.get(url));
                return imgServer.imgMap.get(szSufix+url) || str
            }
        )
    },
    async getImgFromSystem(html) {
        const imgs:any = []
        if (isStringNullOrEmpty(html))return imgs;
        const m = html.match(/src=[\'\"][^\'^\"]+[\'\"]/g)
        if(!m) return []
        for(let i=0; i<m.length; i ++){
            const url = m[i].replace(/^(src=[\'\"])([^\'^\"]+)([\'\"])$/, '$2')
            console.log('url: ', url);
            if (/^atom/.test(url)) {
                const arraySplits  = url.split('.');
                const ext = arraySplits[arraySplits.length-1];

                const fileName = url.replace('atom://','');
                const id = fileName.replace(`.${ext}`,'');

                let data = await model.getImgById(id)
                imgs.push({
                    id,
                    data,
                    ext
                })
            }
        }
        return imgs
    },

    getImageListFromHtml(html) {
        const imgs:any = []
        if (isStringNullOrEmpty(html))return imgs;
        const m = html.match(/src=[\'\"][^\'^\"]+[\'\"]/g)
        if(!m) return []
        for(let i=0; i<m.length; i ++){
            const url = m[i].replace(/^(src=[\'\"])([^\'^\"]+)([\'\"])$/, '$2')
            console.log('url: ', url);
            if (/^atom/.test(url)) {
                const arraySplits  = url.split('.');
                const ext = arraySplits[arraySplits.length-1];

                const fileName = url.replace('atom://','');
                const id = fileName.replace(`.${ext}`,'');

                imgs.push({
                    fileName,
                    id,
                    ext
                })
            }
        }
        return imgs
    }
}


































































































































































































































































































































































